import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";

/**
 * Quiet closing support block. Light card on the light body, not a
 * purple CTA band. Solid purple button + support email text link.
 */
export default function HelpContactCTA() {
  return (
    <section className="bg-[#f7f7f9] pb-16 lg:pb-24">
      <Container className="max-w-2xl">
        <div className="bg-white border border-[#e8e6ef] rounded-xl px-8 py-10 text-center">
          <h3 className="font-heading text-xl font-semibold text-bone mb-2">
            Didn&rsquo;t find your answer?
          </h3>
          <p className="text-prose text-sm mb-6">
            Our team replies within a business day.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to="/contact"
              className="inline-flex items-center bg-cobalt hover:bg-cobalt/90 text-white font-medium px-6 py-2.5 rounded-lg text-sm transition-colors"
            >
              Talk to Our Team
            </Link>
            <a
              href="mailto:info@digital24.com"
              className="text-cobalt font-medium text-sm hover:underline"
            >
              info@digital24.com
            </a>
          </div>
        </div>
      </Container>
    </section>
  );
}